import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { Component } from 'react';
import style from './ToggleEntry.css';
export var ToggleEntry =
/*#__PURE__*/
function (_Component) {
  _inherits(ToggleEntry, _Component);

  function ToggleEntry(_props) {
    var _this;

    _classCallCheck(this, ToggleEntry);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ToggleEntry).call(this));

    _defineProperty(_assertThisInitialized(_this), "_id", null);

    _defineProperty(_assertThisInitialized(_this), "state", {
      active: false
    });

    _defineProperty(_assertThisInitialized(_this), "getCheckBoxId", function () {
      if (!_this._id) {
        _this._id = _this.props.id || '__checkbox_' + ++ToggleEntry.idCounter;
      }

      return _this._id;
    });

    _defineProperty(_assertThisInitialized(_this), "onClick", function (e) {
      e.preventDefault();
      var active = !_this.state.active;

      _this.setState({
        active: active
      });

      if (_this.props.onChange) {
        _this.props.onChange(active);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillReceiveProps", function (props) {
      if (props.active != _this.state.active) {
        _this.setState({
          active: props.active
        });
      }
    });

    _this.state.active = _props.active || false;
    return _this;
  }

  _createClass(ToggleEntry, [{
    key: "render",
    value: function render() {
      return React.createElement("li", {
        className: style.toggleEntry
      }, React.createElement("a", {
        className: style['checkbox-holder'],
        onClick: this.onClick
      }, React.createElement("input", {
        id: this.getCheckBoxId(),
        type: "checkbox",
        checked: this.state.active,
        className: "checkbox",
        readOnly: true
      }), React.createElement("label", {
        htmlFor: this.getCheckBoxId()
      }, this.props.children)));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return ToggleEntry;
}(Component);

_defineProperty(ToggleEntry, "idCounter", 0);

;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ToggleEntry, "ToggleEntry", "/srv/http/owncloud/apps/logreader/js/Components/ToggleEntry.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();